import type { Project } from '../../types'
import { projectNameFor } from '../../utils/crmPipeline'

/** Project name for display. Never the raw project UUID (UX-039). */
export function projectLabel(projects: Project[], projectId: string | undefined | null): string {
  return projectNameFor(projects, projectId) ?? 'Unknown project'
}
